export default __webpack_public_path__ + "static/media/Group 405@3x.ad4851ac.png";